import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'longmoon-sheet-from-gmail',
  templateUrl: './sheet-from-gmail.component.html',
  styleUrls: ['./sheet-from-gmail.component.scss']
})
export class SheetFromGmailComponent implements OnInit {
  pageTitle: string;

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.pageTitle = this.route.snapshot.data.pageTitle;
  }

}
